// The legacy ?wizard= photo-consent state (AI ethics R3/R5/R6). Pure, so it is unit-tested.
// - A photo the parent uploads needs the tick.
// - The free cover's own photo (?fromCover=) needs no tick when the cover holds a stored consent: its photo steps
//   send fromCoverSlug and the server inherits (owner proof required). A cover without one shows the box.
export function wizardPhotoConsent(s: {
  fromCoverSlug: string | null;
  photoUrl: string | null | undefined;
  seedPhotoUrl: string | null;
  coverPhotoConsented: boolean;
  photoConsent: string | null;
}) {
  const isSeedPhoto = !!s.fromCoverSlug && !!s.photoUrl && s.photoUrl === s.seedPhotoUrl;
  const inherited = isSeedPhoto && s.coverPhotoConsented;
  return {
    /** No box: the server inherits the cover's consent. */
    consentNotNeeded: inherited,
    /** Sent with the seed photo's detect/analyze requests (only when no tick is sent). */
    coverSlugForPhoto: inherited && !s.photoConsent ? s.fromCoverSlug : null,
    /** The book request may go: ticked, or the cover's consent is inherited. */
    canCreate: !!s.photoConsent || inherited,
  };
}
